export default __webpack_public_path__ + "static/media/EM1930.34I-42965_-25668_0.7313f857.jpg";